import merge from 'lodash.merge'

import aboutFr from './about/fr.json'
import automationFr from './automation/fr.json'
import rootCh from './ch.json'
import connectorConfigFr from './connectorConfig/fr.json'
import filtersFr from './filters/fr.json'
import rootFr from './fr.json'
import headerFr from './header/fr.json'
import maintenanceFr from './maintenance/fr.json'
import settingsFr from './settings/fr.json'
import stayDisplayerFr from './stayDisplayer/fr.json'

export const codageFr = merge(
  {},
  rootFr,
  aboutFr,
  automationFr,
  connectorConfigFr,
  filtersFr,
  headerFr,
  maintenanceFr,
  stayDisplayerFr,
  settingsFr,
)

export const codageCh = merge(
  {},
  rootCh
)
